(() => {
  const selector = 'video.media-video[data-homepage-autoplay="true"]';
  const observedVideos = new WeakSet();
  let visibilityStarted = false;

  const activate = (video) => {
    if (video.dataset.homepageMediaReady === 'true') return;

    video.querySelectorAll('source[data-homepage-src]').forEach((source) => {
      source.src = source.dataset.homepageSrc;
      source.removeAttribute('data-homepage-src');
    });

    video.dataset.homepageMediaReady = 'true';
    video.autoplay = true;
    video.preload = 'metadata';
    video.load();

    const playback = video.play();
    if (playback) playback.catch(() => {});
  };

  const visibilityObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting || entry.intersectionRatio < 0.25) return;
              visibilityObserver.unobserve(entry.target);
              activate(entry.target);
            });
          },
          { threshold: [0.25] },
        )
      : null;

  const startVisibilityTracking = () => {
    if (!visibilityObserver || visibilityStarted) return;

    visibilityStarted = true;
    document.querySelectorAll(selector).forEach((video) => visibilityObserver.observe(video));
  };

  const observe = (root) => {
    const videos = [];

    if (root instanceof Element && root.matches(selector)) videos.push(root);
    if (root.querySelectorAll) videos.push(...root.querySelectorAll(selector));

    videos.forEach((video) => {
      if (observedVideos.has(video)) return;

      observedVideos.add(video);
      video.addEventListener('pointerdown', () => activate(video), { once: true });
      video.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') activate(video);
      });

      if (visibilityObserver && visibilityStarted) {
        visibilityObserver.observe(video);
      } else if (!visibilityObserver) {
        activate(video);
      }
    });
  };

  observe(document);
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  document.addEventListener('pointerdown', startVisibilityTracking, { once: true, passive: true, capture: true });
  document.addEventListener('touchstart', startVisibilityTracking, { once: true, passive: true, capture: true });
  document.addEventListener('wheel', startVisibilityTracking, { once: true, passive: true, capture: true });
  document.addEventListener('keydown', startVisibilityTracking, { once: true, capture: true });
})();
